import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const getCheckTemplates = async () => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_URL}/api/ingredient-receiving/check-templates`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const createCheckTemplate = async (data) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_URL}/api/ingredient-receiving/check-templates`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const updateCheckTemplate = async (id, data) => {
  const token = localStorage.getItem('token');
  const response = await axios.put(`${API_URL}/api/ingredient-receiving/check-templates/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const deleteCheckTemplate = async (id) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_URL}/api/ingredient-receiving/check-templates/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const reorderCheckTemplates = async (items) => {
  const token = localStorage.getItem('token');
  const response = await axios.put(`${API_URL}/api/ingredient-receiving/check-templates/reorder`, items, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const seedCheckTemplates = async () => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_URL}/api/ingredient-receiving/check-templates/seed`, {}, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const getReceivingLogs = async (filters = {}) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_URL}/api/ingredient-receiving/`, {
    headers: { Authorization: `Bearer ${token}` },
    params: filters,
  });
  return response.data;
};

const getReceivingLog = async (id) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_URL}/api/ingredient-receiving/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const createReceivingLog = async (data) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_URL}/api/ingredient-receiving/`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const updateReceivingLog = async (id, data) => {
  const token = localStorage.getItem('token');
  const response = await axios.put(`${API_URL}/api/ingredient-receiving/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const deleteReceivingLog = async (id) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_URL}/api/ingredient-receiving/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const getDocumentUrl = async (id) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_URL}/api/ingredient-receiving/${id}/document`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data; // { url }
};

const getDocumentUploadUrl = async (id, filename, contentType) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(
    `${API_URL}/api/ingredient-receiving/${id}/document-upload-url`,
    { filename, contentType },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data; // { uploadUrl, key }
};

const uploadDocumentToS3 = async (uploadUrl, file) => {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
  });
  if (!response.ok) throw new Error('S3 upload failed');
};

const getStock = async (params = {}) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_URL}/api/ingredient-receiving/stock`, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
  return response.data;
};

const getStockForIngredient = async (ingredientId) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_URL}/api/ingredient-receiving/stock/${ingredientId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const getByLotCode = async (lotCode, ingredientId) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_URL}/api/ingredient-receiving/by-lot-code`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { lotCode, ingredientId },
  });
  return response.data;
};

const getLotCodesAvailable = async (ingredientId) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_URL}/api/ingredient-receiving/lot-codes-available/${ingredientId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data; // [{ lotCode, receivedKg, usedKg, remainingKg, lastDeliveryDate }]
};

const getByBatch = async (batchId) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_URL}/api/ingredient-receiving/by-batch/${batchId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const getDocumentUploadUrlMulti = async (logId, filename, contentType) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(
    `${API_URL}/api/ingredient-receiving/${logId}/documents/upload-url`,
    { filename, contentType },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data; // { uploadUrl, key }
};

const saveDocument = async (logId, data) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_URL}/api/ingredient-receiving/${logId}/documents`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const getDocumentUrlById = async (logId, docId) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_URL}/api/ingredient-receiving/${logId}/documents/${docId}/url`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data; // { url }
};

const deleteDocument = async (logId, docId) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_URL}/api/ingredient-receiving/${logId}/documents/${docId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const verifyReceivingLog = async (id, data = {}) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_URL}/api/ingredient-receiving/${id}/verify`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const getAdjustments = async (params = {}) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_URL}/api/ingredient-receiving/adjustments`, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
  return response.data;
};

const createAdjustment = async (data) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_URL}/api/ingredient-receiving/adjustments`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const deleteAdjustment = async (id) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_URL}/api/ingredient-receiving/adjustments/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const getPhysicalCountDraftSheet = async () => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_URL}/api/ingredient-receiving/physical-counts/draft-sheet`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const getPhysicalCounts = async () => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_URL}/api/ingredient-receiving/physical-counts`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const getPhysicalCount = async (id) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_URL}/api/ingredient-receiving/physical-counts/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const submitPhysicalCount = async (data) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_URL}/api/ingredient-receiving/physical-counts`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const deletePhysicalCount = async (id) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_URL}/api/ingredient-receiving/physical-counts/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const ingredientInventoryService = {
  getCheckTemplates,
  createCheckTemplate,
  updateCheckTemplate,
  deleteCheckTemplate,
  reorderCheckTemplates,
  seedCheckTemplates,
  getReceivingLogs,
  getReceivingLog,
  createReceivingLog,
  updateReceivingLog,
  deleteReceivingLog,
  getDocumentUrl,
  getDocumentUploadUrl,
  uploadDocumentToS3,
  getStock,
  getStockForIngredient,
  getByLotCode,
  getByBatch,
  getLotCodesAvailable,
  getDocumentUploadUrlMulti,
  saveDocument,
  getDocumentUrlById,
  deleteDocument,
  verifyReceivingLog,
  getAdjustments,
  createAdjustment,
  deleteAdjustment,
  getPhysicalCountDraftSheet,
  getPhysicalCounts,
  getPhysicalCount,
  submitPhysicalCount,
  deletePhysicalCount,
};

export default ingredientInventoryService;
